<template>
  <Layout v-if="type === 'admin'">
      <div>
      <div class="bg-white">
      <div class=" mx-auto sm:px-6  lg:px-6 lg:flex lg:items-center lg:justify-between">
          <div class="flex-shrink-0 h-24 w-24">
          <img
            class="h-24 w-24 rounded-full"
            src="../assets/GraceNew.png"
            alt=""
            />
          </div>
           <!-- <button 
          type="button"
          v-on:click="createArray(); updateSermon();"
          class="relative inline-flex items-center px-5 py-4 border border-transparent text-sm font-medium rounded-md text-blue-600 bg-white hover:text-red-600 focus:outline-none transition duration-150 ease-in-out"
          >
          <img class="h-6 w-6" src="../assets/save.png" alt />
          <a  class="absolute inset-0 z-6 bg-white text-center flex flex-col items-center justify-center opacity-0 hover:opacity-50 bg-opacity-80 duration-300">
         <h1 class=tracking-wider >Update Sermon</h1>
          </a>
        </button>-->
          <h2 v-if="isMember === 'YES'"  class="text-xl leading-9 font-extrabold tracking-tight text-black sm:text-xl md:text-2xl lg:text-2xl sm:leading-10 justify-start text-left">
            Add A Grace Member <a style="color: #C38437" class="text-2xl font-extrabold text-blue-700 sm:text-xl md:text-2xl lg:text-2xl justify-start text-left"></a>
            <br />
          </h2>
              <h2 v-if="isMember === 'NO'"  class="text-xl leading-9 font-extrabold tracking-tight text-red-400 sm:text-xl md:text-2xl lg:text-2xl sm:leading-10 justify-start text-left">
            Add A Non Grace Member <a style="color: #C38437" class="text-2xl font-extrabold text-blue-700 sm:text-xl md:text-2xl lg:text-2xl justify-start text-left"></a>
            <br />
          </h2>
         
         <h2 class="text-xl leading-9 font-extrabold tracking-tight text-black sm:text-xl md:text-2xl lg:text-2xl sm:leading-10 justify-start text-left">
           Member No: <a style="color: #C38437" class="text-2xl font-extrabold text-blue-700 sm:text-xl md:text-2xl lg:text-2xl justify-start text-left">{{ (member.memberID)+1 }}</a>
            <br />
          </h2>
        </div>
      </div>
    </div>
    {{errorMessage}}
        <div class="text-xl text-left text-black">
    <p v-if="errors.length">
      <b></b>
      <ul>
        <div class="text-red-600 text-left">
        <li v-for="error in errors" :key=error>{{ error }}</li>
        </div>
      </ul>
    </p>
    </div>
    <div
      class="bg-white shadow overflow-hidden sm:rounded-lg mt-2"
      v-if="admin"
    >
  
      <div>
        <dl>
            <BaseButton v-on:click="clear();"  >Clear</BaseButton>
                   <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0">
           Is a Member :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
            <select
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5"
              v-model="isMember"
            >
              <option disabled value>...</option>
              <option value="YES">YES</option>
              <option value="NO">NO</option>
            </select>
            </dd>
          </div>
            <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           First Name :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="100" v-model="firstName" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="First Name..."></textarea>
            </dd>
          </div>
             <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Last Name :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="100" v-model="lastName" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Last Name..."></textarea>
            </dd>
          </div>
            <div
            class="bg-gray-50 px-4 pt-2 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Spouse Name :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="100" v-model="spouse" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Spouse Name..."></textarea>
            </dd>
          </div>
       <div
            class="bg-gray-50 px-4 pt-0 py-1 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0">
           Total Children :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
            <select
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5"
              v-model="children"
            >
              <option disabled value>...</option>
              <option value="0">0</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
               <option value="4">4</option>
               <option value="5">5</option>
               <option value="6">6</option>
               <option value="7">7</option>
               <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
            </select>
            </dd>
          </div>
            <div v-if="children >= '1'"
            class="bg-gray-50 px-4 pt-2 py-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Children Names :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="500" v-model="childrenNames" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Children Name..."></textarea>
            </dd>
          </div>
             <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
            Address :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="1000" v-model="address" class ="appearance-none rounded-none resize-none relative h-32 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Address..."></textarea>
            </dd>
          </div>
              <div
            class="bg-gray-50 px-4  py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0 sm:pt-0 md:pt-4 lg:pt-4">
           Date of Birth :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <BaseInput label="" type="date"  placeholder="..." v-model="birthDate" />
            </dd>
          </div>
            <div
            class="bg-gray-50 px-4 pt-0 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0">
           Marriage Status :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
            <select
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5"
              v-model="marriageStatus"
            >
              <option disabled value>...</option>
              <option value="Married">Married</option>
              <option value="Single">Single</option>
              <option value="Divorced">Divorced</option>
              <option value="Widowed">Widowed</option>
              <option value="Seperated">Seperated</option>
            </select>
            </dd>
          </div>
             <div v-if="marriageStatus === 'Married'"
            class="bg-gray-50 px-4 pt-0 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0 sm:pt-0 md:pt-4 lg:pt-4">
           Date of Marriage :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <BaseInput label="" type="date"  placeholder="..." v-model="marriageDate" />
            </dd>
          </div>
             <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Email Address :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="200" v-model="emailAddress" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Email Address..."></textarea>
            </dd>
          </div>
          
              <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Mobile Number :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="12" type="number" v-model="mobileNo" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Mobile Number..."></textarea>
            </dd>
          </div>
              <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Other Tel :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="12" v-model="otherTel" class ="appearance-none rounded-none resize-none relative h-12 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Other Tel..."></textarea>
            </dd>
          </div>
                <div v-if="isMember === 'YES'"
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0">
           Baptized At Grace :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
            <select
              class="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5"
              v-model="baptizedGrace"
            >
              <option disabled value>...</option>
              <option value="YES">YES</option>
              <option value="NO">NO</option>
            </select>
            </dd>
          </div>
                    <div v-if="baptizedGrace === 'NO'"
            class="bg-gray-50 px-4 pt-0 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0 sm:pt-0 md:pt-4 lg:pt-4">
           Date of Baptism Elsewhere :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <BaseInput label="" type="date"  placeholder="..." v-model="baptismDateElse" />
            </dd>
          </div>
             <div v-if="baptizedGrace === 'YES'"
            class="bg-gray-50 px-4 pt-0 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0 sm:pt-0 md:pt-4 lg:pt-4">
           Date of Baptism :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <BaseInput label="" type="date"  placeholder="..." v-model="baptismDate" />
            </dd>
          </div>
          
             <div v-if="isMember === 'YES'"
            class="bg-gray-50 px-4 pt-0 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500 pt-0 sm:pt-0 md:pt-4 lg:pt-4">
           Date of Membership :
            </dt>
            <dd
              class="mt-0 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <BaseInput label="" type="date"  placeholder="..." v-model="membershipDate" />
            </dd>
          </div>
               <div
            class="bg-gray-50 px-4 pt-2 py-0 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
           Additional Information :
            </dt>
            <dd
              class="mt-1 text-sm leading-5 text-blue-600 sm:mt-0 sm:col-span-2"
            >
              <textarea maxlength="2000" v-model="additionalInformation" class ="appearance-none rounded-none resize-none relative h-32 block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:shadow-outline-gray focus:border-yellow-500 focus:z-10 sm:text-sm sm:leading-5" id="Name" placeholder="Additional Information..."></textarea>
            </dd>
          </div>
      
         <div class="pl-4 ml-2 pt-2 bg-gray-50"></div>
            <BaseButton v-if="isMember === 'YES'"  v-on:click="checkForm(); getFullName();  addNumber();  createArray(); addMember();  "  >Add Member</BaseButton>
              <BaseButton v-if="isMember === 'NO'"  v-on:click="checkForm1(); getFullName();  addNumber();  createArray(); addMember();  "  >Add Non Member</BaseButton>
         <!-- <div v-if="admin.document"
            class="bg-gray-50 px-4 py-0 pt-2 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
          >
            <dt class="text-sm leading-5 font-medium text-gray-500">
              Email Manual
            </dt>
            <dd
              class="py-3 px-4 mt-1 text-lg leading-5 text-orange-600 sm:mt-0 sm:col-span-2"
            >
            <input type="email" class="w-80 h-8" id="email" name="user_email" v-model="email" placeholder="Your email.." required>
            <input type="submit" value="Send Now" class=" inline-flex text-xl items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-900 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-blue-600 transition duration-150 ease-in-out">
            </dd>
          </div> -->
          <div>

       </div>
          <div class="pl-10"></div>
        </dl>
      </div>
    </div>

       
  </Layout>
</template>

<script>
import Layout from "./layouts/Main.vue";
//import BaseFileUploader from "../components/BaseFileUploader";
//import BaseFileUploader from "../components/BaseFileUploader";
import BaseButton from "../components/BaseButton";
import BaseInput from "../components/BaseInput";
//import emailjs from 'emailjs-com';
import { mapGetters } from "vuex";

export default {
  name: "adminaddmember",
  components: { Layout, BaseButton, BaseInput},
  data() {
    return {
      admin: {},
      member : "",
      businessPartner: "",
      //fileUrl: "",
      array : "",
      sermonLink: "",
      timer100: "",
      //children:"0",
      marriageStatus :  "",
      firstName : "",
      spouse: "",
      children: "0",
      childrenNames: ".",
      isMember : "NO",
      baptismDateElse: "",
      lastName : "",
      //memberNo : "",
      address: "",
      birthDate : "",
      emailAddress : "",
      fullName : "",
      mobileNo : "",
      otherTel : "",
      memberNo : "",
      baptismDate : "",
      membershipDate : "",
      additionalInformation : "",
      baptizedGrace : "",
      errors: [],
     

    };
  },
  created() {
    this.type = this.currentUserData.userType;
    this.userStatus = this.currentUserData.status;
    if (this.type !== "admin" ) {
      this.$router.push({
        name: "Home",
      });
    }
    this.getMemberNo();
    
    //this.getSermonID();
    //this.getEmployeeCertificate();
    
  },
  mounted(){

    //this.getLicenseData();

  },
  computed: {
    ...mapGetters(["currentUserData"]),
  },
  methods: {
      getMemberNo() {
      const userData = this.$db
        .collection("memberID")
        //.where("user", "==", this.$auth.currentUserData.user);
        .where("active", "==",'yes')
        
      userData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.member = data;
        });
      });
    },
    getFullName(){
      this.fullName = this.firstName + ' ' + this.lastName
      
    },
      createArray(){
      if(!this.array)
      this.array = []

      for (let i = 0; i < this.fullName.length; i++){
      this.array.push(this.fullName.slice(0,i+1).toLowerCase());
      }
    },
    addMember() {
     
     if(this.isMember === 'NO')
     {
      if(this.marriageStatus == 'Married')  
      {
        this.$db.collection("members").add({
          memberNo : this.memberNo,
          firstName : this.firstName,
          lastName : this.lastName,
          fullName : this.fullName,
          NonSearch : this.fullName,
          address : this.address,
          emailAddress : this.emailAddress,
          birthDate : this.birthDate,
          marriageStatus : this.marriageStatus,
          marriageDate : this.marriageDate,
          mobileNo : this.mobileNo,
          otherTel : this.otherTel,
          spouse: this.spouse,
          baptizedGrace : this.baptizedGrace,
          baptismDateElse: this.baptismDateElse,
          baptismDate : this.baptismDate,
          children : this.children,
          childrenNames : this.childrenNames,
         // membershipDate : this.membershipDate,
          additionalInformation : this.additionalInformation,
          addedBy: this.currentUserData.email,
          search: this.array,
          activeMember : "NO",
          isMember: "NO",
        });

        window.confirm(
          "Non Member was added successfully."
        );
        this.updateMemberID();
        this.redirect();
      }
      else
      {
        this.$db.collection("members").add({
          memberNo : this.memberNo,
          firstName : this.firstName,
          lastName : this.lastName,
          fullName : this.fullName,
          address : this.address,
          NonSearch : this.fullName,
          emailAddress : this.emailAddress,
          birthDate : this.birthDate,
          children : this.children,
          spouse: this.spouse,
          childrenNames : this.childrenNames,
          marriageStatus : this.marriageStatus,
          baptismDateElse: this.baptismDateElse,
          //marriageDate : this.marriageDate,
          mobileNo : this.mobileNo,
          otherTel : this.otherTel,
          baptizedGrace : this.baptizedGrace,
          baptismDate : this.baptismDate,
         // membershipDate : this.membershipDate,
          additionalInformation : this.additionalInformation,
          addedBy: this.currentUserData.email,
          search: this.array,
           activeMember : "NO",
           isMember: "NO",
        });

        window.confirm(
          "Non Member was added successfully."
        );
        this.updateMemberID();
        this.redirect();
      }
     }
     else{
      if(this.marriageStatus == 'Married')  
      {
        this.$db.collection("members").add({
          memberNo : this.memberNo,
          firstName : this.firstName,
          lastName : this.lastName,
          fullName : this.fullName,
          address : this.address,
          emailAddress : this.emailAddress,
          birthDate : this.birthDate,
          marriageStatus : this.marriageStatus,
          marriageDate : this.marriageDate,
          mobileNo : this.mobileNo,
          otherTel : this.otherTel,
          spouse: this.spouse,
          baptizedGrace : this.baptizedGrace,
          baptismDateElse: this.baptismDateElse,
          baptismDate : this.baptismDate,
          children : this.children,
          childrenNames : this.childrenNames,
          membershipDate : this.membershipDate,
          additionalInformation : this.additionalInformation,
          addedBy: this.currentUserData.email,
          search: this.array,
          activeMember : "YES",
          isMember: "YES",
        });

        window.confirm(
          "Member was added successfully."
        );
        this.updateMemberID();
        this.redirect();
      }
      else
      {
        this.$db.collection("members").add({
          memberNo : this.memberNo,
          firstName : this.firstName,
          lastName : this.lastName,
          fullName : this.fullName,
          address : this.address,
          emailAddress : this.emailAddress,
          birthDate : this.birthDate,
          children : this.children,
          spouse: this.spouse,
          childrenNames : this.childrenNames,
          marriageStatus : this.marriageStatus,
          baptismDateElse: this.baptismDateElse,
          //marriageDate : this.marriageDate,
          mobileNo : this.mobileNo,
          otherTel : this.otherTel,
          baptizedGrace : this.baptizedGrace,
          baptismDate : this.baptismDate,
          membershipDate : this.membershipDate,
          additionalInformation : this.additionalInformation,
          addedBy: this.currentUserData.email,
          search: this.array,
           activeMember : "YES",
           isMember: "YES",
        });

        window.confirm(
          "Member was added successfully."
        );
        this.updateMemberID();
        this.redirect();
      }
     }
     
      
      
      
    },
    addNumber() {
       this.memberNo = this.member.memberID+=1;
     },
      updateMemberID(){
      this.$db
        .collection("memberID")
        .doc(this.member.id)
        .update({
          memberID: this.memberNo,
        })
        //.then(() => this.getPendingApprovals());
        //this.$router.push({
        //name: "dashboard",})
    },
    clear(){
      this.marriageStatus =  "",
      this.firstName =  "",
      this.lastName =  "",
      this.address =  "",
      this.birthDate =  "",
      this.children = "0",
      this.spouse = "",
      this.childrenNames = ".",
      this.emailAddress =  "",
      this.mobileNo =  "",
      this.otherTel =  "",
      this.baptismDate =  "",
      this.isMember = "NO",
      this.baptismDateElse =  "",
      this.membershipDate =  "",
      this.additionalInformation =  "",
      this.baptizedGrace = "",
      this.fullName = "",
      this.errors = ""

    },
    getSermonID() {
      //const employer = [];
      const certData = this.$db
        .collection("sermonLinks")
        .where("sermonID", "==", this.admin.sermonID)
        
        
      certData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.sermonLink = data;
        });
        //this.removeTicket();
        //this.deleteAttachPlanning();
      });
    },
  

    checkForm: function (e) {
      this.errors = [];

       
        if (!this.firstName) {
          this.errors.push("First Name is required...");
        }
        if (!this.lastName) {
          this.errors.push("Last Name is required...");
        }
        if (!this.address) {
          this.errors.push("Address is required...");
        }
        if (!this.birthDate) {
          this.errors.push("birth Date is required...");
        }
        if (!this.marriageStatus) {
          this.errors.push("Marriage Status is required...");
        }
        if (!this.emailAddress) {
          this.errors.push("Email Address is required...");
        }
        if (!this.mobileNo) {
          this.errors.push("Mobile is required...");
        }
        if (!this.otherTel) {
          this.errors.push("Other Tel is required...");
        }
        if (!this.baptizedGrace) {
          this.errors.push("Baptized at Grace is required...");
        }
       
        if (!this.membershipDate) {
          this.errors.push("Membership Date is required...");
        }
        if (!this.errors.length) {
          return true;
        }

        e.preventDefault();
      },
          checkForm1: function (e) {
      this.errors = [];

       
        if (!this.firstName) {
          this.errors.push("First Name is required...");
        }
        if (!this.lastName) {
          this.errors.push("Last Name is required...");
        }
        if (!this.address) {
          this.errors.push("Address is required...");
        }
        if (!this.birthDate) {
          this.errors.push("birth Date is required...");
        }
        if (!this.marriageStatus) {
          this.errors.push("Marriage Status is required...");
        }
        if (!this.emailAddress) {
          this.errors.push("Email Address is required...");
        }
        if (!this.mobileNo) {
          this.errors.push("Mobile is required...");
        }
        if (!this.otherTel) {
          this.errors.push("Other Tel is required...");
        }
  

        if (!this.errors.length) {
          return true;
        }

        e.preventDefault();
      },
    updateSermonLink() {
      this.$db
        .collection("sermonLinks")
        .doc(this.sermonLink.id)
        .update({
          //clientName: this.company.clientName.toLowerCase(),
         document: this.sermonLink.document,
        
        });
      //this.pages.homeJobSeeker = this.homeJobSeeker,
      window.confirm("Sermon Link Has been updated.");
       this.timer100 = setTimeout(this.getSermonID, 1000)
    },


    redirect() {
      this.$router.push({
      name: "dashboard",
      });
    },

  }
};
</script>
